import endereco from './endereco'

export default baseUrl => {
    baseUrl = `${baseUrl}/integracao`

    return {
        endereco: endereco(baseUrl),
    }
}